import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import asistReducer from "./asistSlice";
import tareaSlice from "./tareaSlice";
import notificationsReducer from "./notificationsSlice";
import twilioPhoneReducer from "./twilioPhoneSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  asist: asistReducer,
  tarea: tareaSlice,
  notifications: notificationsReducer,
  twilioPhone: twilioPhoneReducer,
});

export default rootReducer;